import * as Effects from 'redux-saga/effects'
import { put } from 'redux-saga/effects'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import { fireToastSuccess } from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import { RentLicensesActions } from '../../reducers/rentLicenses/actionNames'
import { getCalendarId } from '../../reducers/bookingCalendar/selectors/calendar'
import deleteRentLicenses from '../../models/RentLicenses/deleteRentLicenses'

function* removeRentLicenses(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.DeleteRentLicenses)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, deleteRentLicenses),
      ),
    ])

    const calendarId = yield Effects.select(getCalendarId)

    yield Effects.call(service, String(calendarId), action.payload)

    // yield Effects.put({
    //   services,
    //   type: PaymentDictionaryActions.AcceptedPrepayment,
    // })
    yield put(fireToastSuccess(i18n.t('user_settings_updated')))
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeEvery(
    RentLicensesActions.DeleteRentLicense,
    removeRentLicenses,
  )
}
